export const BANK_ID_THUMBPRINT_HEADER = "x-certificate-thumbprint";
class HttpRequestBuilder {
    constructor() {
        this._method = "get";
        this._headers = {};
        this._body = null;
    }
    accept(acceptHeader) {
        this._headers.Accept = acceptHeader;
        return this;
    }
    method(method) {
        this._method = method;
        return this;
    }
    authorization(token) {
        this._headers.Authorization = `Bearer ${token}`;
        return this;
    }
    requestForgeryToken(token) {
        if (!token)
            throw new Error("Missing request forgery token");
        this._headers["x-rf-token"] = token;
        return this;
    }
    content(body, contentType = "application/json") {
        switch (contentType) {
            case "application/json":
                this._body = JSON.stringify(body);
                break;
            default:
                this._body = body;
                break;
        }
        if (contentType)
            this._headers["Content-Type"] = contentType;
        return this;
    }
    bankIdThumbprint(thumbprint) {
        if (!thumbprint)
            throw new Error("Bank id thumbprint can not be falsy");
        this._headers[BANK_ID_THUMBPRINT_HEADER] = thumbprint;
        return this;
    }
    build() {
        return {
            body: this._body,
            headers: this._headers,
            method: this._method,
        };
    }
}
export default HttpRequestBuilder;
